window.PUBLIC_DEALER_STORES = {
    'type': 'FeatureCollection',
    'features': [
        {
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -79.3825351,
                    40.112573
                ]
            },
            "properties": {
                "name": "Always Boardshop",
                "phoneFormatted": "(724) 593-7800",
                "phone": "7245937800",
                "address": "3856 Route 31",
                "city": "Donegal",
                "country": "United States",
                "postalCode": "15646",
                "state": "PA",
                "url": "https://alwaysboardshop.com/"
            }
        },
        {
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -149.109207572,
                    60.944861988
                ]
            },
            "properties": {
                "name": "Alyeska Resort",
                "phoneFormatted": "(800) 880-3880",
                "phone": "8008803880",
                "address": "1000 Arlberg Ave",
                "city": "Girdwood",
                "country": "United States",
                "postalCode": "99587",
                "state": "AK",
                "url": "https://www.alyeskaresort.com/"
            }
        },
        {
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -73.176273,
                    44.4642957
                ]
            },
            "properties": {
                "name": "Alpine Shop",
                "phoneFormatted": "(802) 862-2714",
                "phone": "8028622714",
                "address": "947 Shelburne Rd",
                "city": "South Burlington",
                "country": "United States",
                "postalCode": "05403",
                "state": "VT",
                "url": "https://www.alpineshopvt.com/"
            }
        },
        {
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -120.32870676789,
                    47.4271328437883
                ]
            },
            "properties": {
                "name": "Arlberg Sports",
                "phoneFormatted": "(509) 663-7401",
                "phone": "5096637401",
                "address": "25 N Wenatchee Ave",
                "city": "Wenatchee",
                "country": "United States",
                "postalCode": "98801",
                "state": "WA",
                "url": "https://www.arlbergsports.com/"
            }
        },
        {
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -83.0101843,
                    40.1983958
                ]
            },
            "properties": {
                "name": "Aspen Ski and Board",
                "phoneFormatted": "(614) 848-6600",
                "phone": "6148486600",
                "address": "1170 E Powell Rd",
                "city": "Lewis Center",
                "country": "United States",
                "postalCode": "43035",
                "state": "OH",
                "url": "https://www.aspenskiandboard.com/"
            }
        },
        {
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -117.91768864286,
                    33.6461964374135
                ]
            },
            "properties": {
                "name": "Attic Skate Shop",
                "phoneFormatted": "(949) 645-3457",
                "phone": "9496453457",
                "address": "2588 Newport Blvd Unit B",
                "city": "Costa Mesa",
                "country": "United States",
                "postalCode": "92627",
                "state": "CA",
                "url": "https://www.atticskateshop.com/"
            }
        },
        {
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -116.900076945945,
                    34.2446859695945
                ]
            },
            "properties": {
                "name": "Attic Skate Shop Big Bear",
                "phoneFormatted": "(909) 969-4725",
                "phone": "9099694725",
                "address": "42698 Moonridge Rd",
                "city": "Big Bear Lake",
                "country": "United States",
                "postalCode": "92315",
                "state": "CA",
                "url": "https://www.atticskateshop.com/"
            }
        },


        {
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -118.004435489138,
                    33.7170844946937
                ]
            },
            "properties": {
                "name": "Baker Street Snow",
                "phoneFormatted": "(714) 852-3562",
                "phone": "7148523562",
                "address": "17031 Newland St",
                "city": "Huntington Beach",
                "country": "United States",
                "postalCode": "92647",
                "state": "CA",
                "url": "https://bakerstsnow.com/"
            }
        },

        {
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -104.881048888461,
                    39.5465274291208
                ]
            },
            "properties": {
                "name": "BC Surf & Sport",
                "phoneFormatted": "(303) 768-8908",
                "phone": "3037688908",
                "address": "8678 Park Meadows Center Dr.",
                "city": "Lonetree",
                "country": "United States",
                "postalCode": "80124",
                "state": "CO",
                "url": "https://www.bcsurf.com/"
            }
        },
        {
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -116.900076945945,
                    34.2446859695945
                ]
            },
            "properties": {
                "name": "Blauer Board Shop",
                "phoneFormatted": "(909) 866-5689",
                "phone": "9098665689",
                "address": "41177 Big Bear Blvd",
                "city": "Big Bear Lake",
                "country": "United States",
                "postalCode": "92315",
                "state": "CA",
                "url": "https://blauerboardshop.com/"
            }
        },
        {
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -113.994299823201,
                    46.8546243432853
                ]
            },
            "properties": {
                "name": "Board of Missoula",
                "phoneFormatted": "(406) 721-7774",
                "phone": "4067217774",
                "address": "618 S Higgins Ave",
                "city": "Missoula",
                "country": "United States",
                "postalCode": "59801",
                "state": "MT",
                "url": "https://boardofmissoula.com/"
            }
        },
        {
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -111.6587085,
                    40.2337289
                ]
            },
            "properties": {
                "name": "Board of Provo",
                "phoneFormatted": "(801) 356-3185",
                "phone": "8013563185",
                "address": "465 N. University Ave",
                "city": "Provo",
                "country": "United States",
                "postalCode": "84041",
                "state": "UT",
                "url": "https://boardofprovo.com/"
            }
        },
        {
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -84.95533,
                    45.373343
                ]
            },
            "properties": {
                "name": "Boyne Country Sports",
                "phoneFormatted": "(231) 439-4906",
                "phone": "2314394906",
                "address": "1200 Bay View Rd",
                "city": "Petoskey",
                "country": "United States",
                "postalCode": "49770",
                "state": "MI",
                "url": "https://boynecountrysports.com/pages/stores"
            }
        },
        {
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -75.2910925,
                    40.007939
                ]
            },
            "properties": {
                "name": "Buckman's Ski & Snowboard Shop Ardmore",
                "phoneFormatted": "(610) 658-0470",
                "phone": "6106580470",
                "address": "26 W. Lancaster Avenue",
                "city": "Ardmore",
                "country": "United States",
                "postalCode": "19003",
                "state": "PA",
                "url": "https://buckmans.com/"
            }
        },
        {
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -75.127557454677,
                    40.3138862706459
                ]
            },
            "properties": {
                "name": "Buckman's Ski & Snowboard Shop Doylestown",
                "phoneFormatted": "(215) 348-5624",
                "phone": "2153485624",
                "address": "635 North Main Street",
                "city": "Doylestown",
                "country": "United States",
                "postalCode": "18901",
                "state": "PA",
                "url": "https://buckmans.com/"
            }
        },
        {
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -75.6467302477648,
                    40.0451020630223
                ]
            },
            "properties": {
                "name": "Buckman's Ski & Snowboard Shop Exton",
                "phoneFormatted": "(610) 363-1893",
                "phone": "6103631893",
                "address": "403 Pottstown Pike",
                "city": "Exton",
                "country": "United States",
                "postalCode": "19341",
                "state": "PA",
                "url": "https://buckmans.com/"
            }
        },
        {
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -75.3888122,
                    40.0851221
                ]
            },
            "properties": {
                "name": "Buckman's Ski & Snowboard Shop King of Prussia",
                "phoneFormatted": "(610) 265-3330",
                "phone": "6102653330",
                "address": "740 DeKalb Pike",
                "city": "King of Prussia",
                "country": "United States",
                "postalCode": "19406",
                "state": "PA",
                "url": "https://buckmans.com/"
            }
        },
        {
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -75.2437854,
                    40.2473291
                ]
            },
            "properties": {
                "name": "Buckman's Ski & Snowboard Shop Montgomeryville",
                "phoneFormatted": "(215) 368-4418",
                "phone": "2153684418",
                "address": "925 Bethlehem Pike (Route 309)",
                "city": "Montgomeryville",
                "country": "United States",
                "postalCode": "18936",
                "state": "PA",
                "url": "https://buckmans.com/"
            }
        },
        {
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -75.9279495,
                    40.335345
                ]
            },
            "properties": {
                "name": "Buckman's Ski & Snowboard Shop Reading",
                "phoneFormatted": "(610) 678-5960",
                "phone": "6106785960",
                "address": "301 E. Bellevue Ave.",
                "city": "Reading",
                "country": "United States",
                "postalCode": "19605",
                "state": "PA",
                "url": "https://buckmans.com/"
            }
        },
        {
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -75.4955545207118,
                    40.6497602418158
                ]
            },
            "properties": {
                "name": "Buckman's Ski & Snowboard Shop Whitehall",
                "phoneFormatted": "(610) 435-1242",
                "phone": "6104351242",
                "address": "2510 MacArthur Road",
                "city": "Whitehall",
                "country": "United States",
                "postalCode": "18052",
                "state": "PA",
                "url": "https://buckmans.com/"
            }
        },
        {
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -73.0821545,
                    40.7361036
                ]
            },
            "properties": {
                "name": "Bunger",
                "phoneFormatted": "(631) 244-7070",
                "phone": "6312447070",
                "address": "247A W Main St",
                "city": "Sayville",
                "country": "United States",
                "postalCode": "11782",
                "state": "NY",
                "url": "https://www.bungersayville.com/"
            }
        },
        {
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -93.2883981723806,
                    44.9457246229198
                ]
            },
            "properties": {
                "name": "Cal Surf",
                "phoneFormatted": "(612) 822-6840",
                "phone": "6128226840",
                "address": "1715 W Lake St",
                "city": "Minneapolis",
                "country": "United States",
                "postalCode": "55408",
                "state": "MN",
                "url": "https://www.cal-surf.com/"
            }
        },
        {
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -122.602430588656,
                    45.5597261583507
                ]
            },
            "properties": {
                "name": "CCS Portland Shop",
                "phoneFormatted": "(971) 229-0871",
                "phone": "9712290871",
                "address": "5909 NE 80th Ave",
                "city": "Portland",
                "country": "United States",
                "postalCode": "97218",
                "state": "OR",
                "url": "https://shop.ccs.com/pages/portland-skate-shop"
            }
        },
        {
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -89.6272791,
                    44.9597858
                ]
            },
            "properties": {
                "name": "Central Board Shop",
                "phoneFormatted": "(715) 848-0400",
                "phone": "7158480400",
                "address": "426 N 3rd Street",
                "city": "Wausau",
                "country": "United States",
                "postalCode": "54403",
                "state": "WI",
                "url": "https://www.central-boardshop.com/"
            }
        },
        {
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -71.4884081637991,
                    41.6443143395348
                ]
            },
            "properties": {
                "name": "Civil Skateboard Shop - East Greenwich",
                "phoneFormatted": "(401) 886-5116",
                "phone": "4018865116",
                "address": "86 Main Street",
                "city": "East Greenwich",
                "country": "United States",
                "postalCode": "02818",
                "state": "RI",
                "url": "https://wearecivil.com/"
            }
        },
        {
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -71.4092735772321,
                    41.8212421598214
                ]
            },
            "properties": {
                "name": "Civil Skateboard Shop - Providence",
                "phoneFormatted": "(401) 383-1622",
                "phone": "4013831622",
                "address": "231 Westminster St",
                "city": "Providence",
                "country": "United States",
                "postalCode": "02903",
                "state": "RI",
                "url": "https://wearecivil.com/"
            }
        },
        {
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -71.8230528028301,
                    41.3509002245283
                ]
            },
            "properties": {
                "name": "Civil Skateboard Shop - Westerly",
                "phoneFormatted": "(401) 596-0028",
                "phone": "4015960028",
                "address": "130 Granite Street",
                "city": "Westerly",
                "country": "United States",
                "postalCode": "02891",
                "state": "RI",
                "url": "https://wearecivil.com/"
            }
        },
        {
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -111.962268341604,
                    41.2670590179295
                ]
            },
            "properties": {
                "name": "Crossroads Skateshop",
                "phoneFormatted": "(801) 605-3986",
                "phone": "8016053986",
                "address": "251 W 12th St",
                "city": "Ogden",
                "country": "United States",
                "postalCode": "84404",
                "state": "UT",
                "url": "https://www.crossroadsskateshop.com/"
            }
        },
        {
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -72.7456519,
                    41.621488
                ]
            },
            "properties": {
                "name": "Cutting Edge",
                "phoneFormatted": "(860) 828-3428",
                "phone": "8608283428",
                "address": "146 Mill St",
                "city": "Berlin",
                "country": "United States",
                "postalCode": "06037",
                "state": "CT",
                "url": "https://www.cuttingedgect.com/"
            }
        },
        {
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -92.1351612518882,
                    46.7658109637351
                ]
            },
            "properties": {
                "name": "Damage Boardshop",
                "phoneFormatted": "(218) 724-4027",
                "phone": "2187244027",
                "address": "1904 W Superior St",
                "city": "Duluth",
                "country": "United States",
                "postalCode": "55806",
                "state": "MN",
                "url": "http://www.damageboardshop.com/"
            }
        },
        {
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -72.7784445,
                    43.67433
                ]
            },
            "properties": {
                "name": "Darkside Snowboards",
                "phoneFormatted": "(802) 422-8600",
                "phone": "8024228600",
                "address": "1842 Killington Rd",
                "city": "Killington",
                "country": "United States",
                "postalCode": "05751",
                "state": "VT",
                "url": "https://www.darksidesnowboards.com/"
            }
        },
        {
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -73.4284591,
                    45.6714857
                ]
            },
            "properties": {
                "name": "Deuxième Vague",
                "phoneFormatted": "+1 514-941-4504",
                "phone": "+15149414504",
                "address": "199 Chemin Du Petit Bois, Local 101",
                "city": "Varennes",
                "country": "Canada",
                "postalCode": "J3X 1P7",
                "state": "QC",
                "url": "http://www.deuxiemevague.com/"
            }
        },
        {
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -111.828680962317,
                    41.737295234059
                ]
            },
            "properties": {
                "name": "Directive Boardshop",
                "phoneFormatted": "(435) 752-0155",
                "phone": "4357520155",
                "address": "65 S Main St",
                "city": "Logan",
                "country": "United States",
                "postalCode": "84321",
                "state": "UT",
                "url": "https://www.directiveboardshop.com/"
            }
        },
        {
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -71.8018877,
                    42.2625621
                ]
            },
            "properties": {
                "name": "Eastern Boarder",
                "phoneFormatted": "(508) 852-3668",
                "phone": "5088523668",
                "address": "7 Jackson St",
                "city": "Worcester",
                "country": "United States",
                "postalCode": "01608",
                "state": "MA",
                "url": "https://easternboarder.com/"
            }
        },
        {
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -104.996730963,
                    39.750985333
                ]
            },
            "properties": {
                "name": "Emage",
                "phoneFormatted": "(720) 855-8297",
                "phone": "7208558297",
                "address": "1620 Platte St",
                "city": "Denver",
                "country": "United States",
                "postalCode": "80202",
                "state": "CO",
                "url": "https://www.emagenetwork.com/"
            }
        },
        {
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -111.897838184,
                    40.755424441
                ]
            },
            "properties": {
                "name": "evo Salt Lake City Flagship Store",
                "phoneFormatted": "(385) 379-3172",
                "phone": "3853793172",
                "address": "660 S 400 W, Suite 300",
                "city": "Salt Lake City",
                "country": "United States",
                "postalCode": "84101",
                "state": "UT",
                "url": "https://www.evo.com/locations/salt-lake-city"
            }
        },
        {
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -122.344015221,
                    47.673544448
                ]
            },
            "properties": {
                "name": "evo Seattle Flagship Store",
                "phoneFormatted": "(206) 973-4470",
                "phone": "2069734470",
                "address": "3500 Stone Way N",
                "city": "Seattle",
                "country": "United States",
                "postalCode": "98103",
                "state": "WA",
                "url": "https://www.evo.com/locations/seattle"
            }
        },
        {
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -95.3809569396039,
                    45.8848614971287
                ]
            },
            "properties": {
                "name": "Faction",
                "phoneFormatted": "(320) 762-2574",
                "phone": "3207622574",
                "address": "612 Broadway St",
                "city": "Alexandria",
                "country": "United States",
                "postalCode": "56308",
                "state": "MN",
                "url": "https://www.factionboardshop.com/"
            }
        },
        {
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -89.3489422234375,
                    43.119860428125
                ]
            },
            "properties": {
                "name": "Focus Boardshop",
                "phoneFormatted": "(608) 242-8403",
                "phone": "6082428403",
                "address": "2358 E Springs Dr",
                "city": "Madison",
                "country": "United States",
                "postalCode": "53704",
                "state": "WI",
                "url": "https://www.focusmadison.com/"
            }
        },
        {
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -77.0047276,
                    40.2101972
                ]
            },
            "properties": {
                "name": "Funtastik Skate and Snowboard Shop",
                "phoneFormatted": "(717) 697-6692",
                "phone": "7176976692",
                "address": "18 W Main St",
                "city": "Mechanicsburg",
                "country": "United States",
                "postalCode": "17055",
                "state": "PA",
                "url": "https://www.facebook.com/funtastiks"
            }
        },
        {
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -93.5715908,
                    44.9863892
                ]
            },
            "properties": {
                "name": "Gear West",
                "phoneFormatted": "(952) 473-0377",
                "phone": "9524730377",
                "address": "1786 Wayzata Blvd",
                "city": "Long Lake",
                "country": "United States",
                "postalCode": "55356",
                "state": "MN",
                "url": "https://www.gearwest.com/"
            }
        },
        {
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -122.691135807072,
                    45.4873877369736
                ]
            },
            "properties": {
                "name": "Gorge Performance",
                "phoneFormatted": "(503) 246-6646",
                "phone": "5032466646",
                "address": "6626 S Macadam Avenue",
                "city": "Portland",
                "country": "United States",
                "postalCode": "97239",
                "state": "OR",
                "url": "https://www.gorgeperformance.com/"
            }
        },
        {
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -115.1484131,
                    36.1674263
                ]
            },
            "properties": {
                "name": "Gravity Sports Las Vegas",
                "phoneFormatted": "(702) 665-6840",
                "phone": "7026656840",
                "address": "9775 W Russell Rd Ste 130",
                "city": "Las Vegas",
                "country": "United States",
                "postalCode": "89148",
                "state": "NV",
                "url": "https://gravitysportslv.com/"
            }
        },
        {
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -75.2563171136,
                    41.5908358279999
                ]
            },
            "properties": {
                "name": "Guenther's Ski Haus",
                "phoneFormatted": "(570) 253-5528",
                "phone": "5702535528",
                "address": "945 Main St.",
                "city": "Honesdale",
                "country": "United States",
                "postalCode": "18431",
                "state": "PA",
                "url": "https://www.guenthersskihaus.com/"
            }
        },
        {
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -75.1812913,
                    40.9995386
                ]
            },
            "properties": {
                "name": "Holy Stokes",
                "phoneFormatted": "(570) 213-8357",
                "phone": "5702138357",
                "address": "114 Washington St Suite 200",
                "city": "East Stroudsburg",
                "country": "United States",
                "postalCode": "18301",
                "state": "PA",
                "url": "https://holystokes.com/"
            }
        },
        {
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -117.876762421206,
                    33.6333675527203
                ]
            },
            "properties": {
                "name": "Jack's Surfboards Corona Del Mar",
                "phoneFormatted": "(949) 718-0001",
                "phone": "9497180001",
                "address": "900 Avocado Ave",
                "city": "Newport Beach",
                "country": "United States",
                "postalCode": "92660",
                "state": "CA",
                "url": "https://jackssurfboards.com/"
            }
        },
        {
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -117.702256786408,
                    33.4783848059918
                ]
            },
            "properties": {
                "name": "Jack's Surfboards Dana Point",
                "phoneFormatted": "(949) 276-8080",
                "phone": "9492768080",
                "address": "34320 Pacific Coast Highway",
                "city": "Dana Point",
                "country": "United States",
                "postalCode": "92629",
                "state": "CA",
                "url": "https://jackssurfboards.com/"
            }
        },
        {
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -118.397423727,
                    33.866736539
                ]
            },
            "properties": {
                "name": "Jack's Surfboards Hermosa Beach",
                "phoneFormatted": "(310) 374-7873",
                "phone": "3103747873",
                "address": "1630 Pacific Coast Highway",
                "city": "Hermosa Beach",
                "country": "United States",
                "postalCode": "90254",
                "state": "CA",
                "url": "https://jackssurfboards.com/"
            }
        },
        {
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -118.004435489138,
                    33.7170844946937
                ]
            },
            "properties": {
                "name": "Jack's Surfboards HQ",
                "phoneFormatted": "(714) 698-5777",
                "phone": "7146985777",
                "address": "16350 Gothard Street, Suite 101",
                "city": "Huntington Beach",
                "country": "United States",
                "postalCode": "92647",
                "state": "CA",
                "url": "https://jackssurfboards.com/"
            }
        },
        {
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -118.003246559065,
                    33.6768319627638
                ]
            },
            "properties": {
                "name": "Jack's Surfboards Huntington Beach",
                "phoneFormatted": "(714) 536-4516",
                "phone": "7145364516",
                "address": "101 Main Street",
                "city": "Huntington Beach",
                "country": "United States",
                "postalCode": "92648",
                "state": "CA",
                "url": "https://jackssurfboards.com/"
            }
        },
        {
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -117.928302790872,
                    33.6202656802816
                ]
            },
            "properties": {
                "name": "Jack's Surfboards Newport Beach",
                "phoneFormatted": "(949) 673-2300",
                "phone": "9496732300",
                "address": "2727 Newport Blvd",
                "city": "Newport Beach",
                "country": "United States",
                "postalCode": "92663",
                "state": "CA",
                "url": "https://jackssurfboards.com/"
            }
        },
        {
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -118.466750164,
                    34.0099954696
                ]
            },
            "properties": {
                "name": "Jack's Surfboards Santa Monica",
                "phoneFormatted": "(310) 450-6569",
                "phone": "3104506569",
                "address": "2012 Lincoln Blvd",
                "city": "Santa Monica",
                "country": "United States",
                "postalCode": "90405",
                "state": "CA",
                "url": "https://jackssurfboards.com/"
            }
        },
        {
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -75.546589,
                    39.7459468
                ]
            },
            "properties": {
                "name": "Kinetic Skateboarding",
                "phoneFormatted": "(302) 477-1533",
                "phone": "3024771533",
                "address": "3906 Concord Pike",
                "city": "Wilmington",
                "country": "United States",
                "postalCode": "19803",
                "state": "DE",
                "url": "https://kineticskateboarding.com/"
            }
        },
        {
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -88.1497867147918,
                    43.0593193397087
                ]
            },
            "properties": {
                "name": "Les Moise - Brookfield",
                "phoneFormatted": "(262) 879-0800",
                "phone": "2628790800",
                "address": "19730 W. Bluemound Rd.",
                "city": "Brookfield",
                "country": "United States",
                "postalCode": "53045",
                "state": "WI",
                "url": "http://www.lesmoiseinc.com/"
            }
        },
        {
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -87.9387109832346,
                    43.2123171344187
                ]
            },
            "properties": {
                "name": "Les Moise - Mequon",
                "phoneFormatted": "(262) 518-0069",
                "phone": "2625180069",
                "address": "10130 N. Port Washington Rd",
                "city": "Mequon",
                "country": "United States",
                "postalCode": "53092",
                "state": "WI",
                "url": "http://www.lesmoiseinc.com/"
            }
        },
        {
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -111.814292226794,
                    40.7045352097212
                ]
            },
            "properties": {
                "name": "Level Nine Sports Millcreek",
                "phoneFormatted": "(801) 466-9880",
                "phone": "8014669880",
                "address": "2927 E 3300 S",
                "city": "Millcreek",
                "country": "United States",
                "postalCode": "84109",
                "state": "UT",
                "url": "http://www.levelninesports.com"
            }
        },
        {
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -111.962268341604,
                    41.2670590179295
                ]
            },
            "properties": {
                "name": "Level Nine Sports Ogden",
                "phoneFormatted": "(801) 621-2003",
                "phone": "8016212003",
                "address": "1273 Canyon Rd",
                "city": "Ogden",
                "country": "United States",
                "postalCode": "84404",
                "state": "UT",
                "url": "http://www.levelninesports.com"
            }
        },
        {
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -111.706119143817,
                    40.3170719708099
                ]
            },
            "properties": {
                "name": "Level Nine Sports Orem",
                "phoneFormatted": "(801) 607-2493",
                "phone": "8016072493",
                "address": "644 N State St",
                "city": "Orem",
                "country": "United States",
                "postalCode": "84057",
                "state": "UT",
                "url": "http://www.levelninesports.com"
            }
        },
        {
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -111.897838184,
                    40.755424441
                ]
            },
            "properties": {
                "name": "Level Nine Sports Salt Lake City",
                "phoneFormatted": "(801) 973-7350",
                "phone": "8019737350",
                "address": "660 S 400 W",
                "city": "Salt Lake City",
                "country": "United States",
                "postalCode": "84101",
                "state": "UT",
                "url": "http://www.levelninesports.com"
            }
        },
        {
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -121.075627789156,
                    38.9198357807228
                ]
            },
            "properties": {
                "name": "Milo Snow and Skate",
                "phoneFormatted": "(530) 878-5889",
                "phone": "5308785889",
                "address": "905 Lincoln Way",
                "city": "Auburn",
                "country": "United States",
                "postalCode": "95603",
                "state": "CA",
                "url": "https://www.milosnowandskate.com/"
            }
        },
        {
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -111.886797,
                    40.7596198
                ]
            },
            "properties": {
                "name": "Milosport",
                "phoneFormatted": "(801) 487-8600",
                "phone": "8014878600",
                "address": "3119 E 3300 S",
                "city": "Salt Lake City",
                "country": "United States",
                "postalCode": "84109",
                "state": "UT",
                "url": "https://www.milosport.com/"
            }
        },
        {
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -83.1366517783804,
                    42.4901583193563
                ]
            },
            "properties": {
                "name": "Modern Skate & Surf",
                "phoneFormatted": "(248) 546-7275",
                "phone": "2485467275",
                "address": "1500 N Stephenson Hwy",
                "city": "Royal Oak",
                "country": "United States",
                "postalCode": "48067",
                "state": "MI",
                "url": "https://www.modernskate.com/"
            }
        },
        {
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -74.0326395,
                    40.9912087
                ]
            },
            "properties": {
                "name": "Mount Everest",
                "phoneFormatted": "(201) 664-2500",
                "phone": "2016642500",
                "address": "318 3rd Ave",
                "city": "Westwood",
                "country": "United States",
                "postalCode": "07675",
                "state": "NJ",
                "url": "http://www.ridemteverest.com/"
            }
        },
        {
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -78.6727799,
                    42.2751873
                ]
            },
            "properties": {
                "name": "Mud Sweat n' Gears",
                "phoneFormatted": "(716) 699-8300",
                "phone": "7166998300",
                "address": "18 Monroe St",
                "city": "Ellicottville",
                "country": "United States",
                "postalCode": "14731",
                "state": "NY",
                "url": "https://mudsweatgears.com/"
            }
        },
        {
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -122.638896239793,
                    45.5142551086671
                ]
            },
            "properties": {
                "name": "Next Adventure - Grand Ave Outdoor Store",
                "phoneFormatted": "(503) 233-0706",
                "phone": "5032330706",
                "address": "426 SE Grand Ave.",
                "city": "Portland",
                "country": "United States",
                "postalCode": "97214",
                "state": "OR",
                "url": "https://www.nextadventure.net/contacts/detail/index/id/27"
            }
        },
        {
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -122.257798616407,
                    45.3947142523919
                ]
            },
            "properties": {
                "name": "Next Adventure - Sandy",
                "phoneFormatted": "(503) 668-6500",
                "phone": "5036686500",
                "address": "38454 Pioneer Blvd",
                "city": "Sandy",
                "country": "United States",
                "postalCode": "97055",
                "state": "OR",
                "url": "https://www.nextadventure.net/contacts/detail/index/id/7134"
            }
        },
        {
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -74.4937437790566,
                    41.1877090032075
                ]
            },
            "properties": {
                "name": "Outkast Sports",
                "phoneFormatted": "(862) 266-3582",
                "phone": "8622663582",
                "address": "216 NJ-94",
                "city": "Vernon Township",
                "country": "United States",
                "postalCode": "07462",
                "state": "NJ",
                "url": "https://www.rideoutkast.com/"
            }
        },
        {
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -90.4433296553351,
                    38.6139254828595
                ]
            },
            "properties": {
                "name": "Outpost Board shop",
                "phoneFormatted": "(314) 965-1444",
                "phone": "3149651444",
                "address": "12011 Manchester Rd",
                "city": "St Louis",
                "country": "United States",
                "postalCode": "63131",
                "state": "MO",
                "url": "https://outpostboardshop.com/"
            }
        },
        {
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -73.7501794912504,
                    41.0096197050674
                ]
            },
            "properties": {
                "name": "Pedigree Ski Shop",
                "phoneFormatted": "(914) 948-2995",
                "phone": "9149482995",
                "address": "355 Mamaroneck Ave",
                "city": "White Plains",
                "country": "United States",
                "postalCode": "10605",
                "state": "NY",
                "url": "https://www.pedigreeskishop.com/"
            }
        },
        {
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -73.7001868,
                    41.2366622
                ]
            },
            "properties": {
                "name": "Pedigree Ski Shop",
                "phoneFormatted": "(914) 244-8960",
                "phone": "9142448960",
                "address": "532 Bedford Rd.",
                "city": "Bedford Hills",
                "country": "United States",
                "postalCode": "10507",
                "state": "NY",
                "url": "https://www.pedigreeskishop.com/"
            }
        },
        {
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -74.4811234,
                    40.8221007
                ]
            },
            "properties": {
                "name": "Pelican Snowboard Shop",
                "phoneFormatted": "(973) 267-0964",
                "phone": "9732670964",
                "address": "2980 Route 10",
                "city": "Morris Plains",
                "country": "United States",
                "postalCode": "07950",
                "state": "NJ",
                "url": "https://pelicanshops.com/locations/morris-plains/"
            }
        },
        {
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -83.3438248,
                    42.6080884
                ]
            },
            "properties": {
                "name": "People Skate and Snowboard",
                "phoneFormatted": "(248) 499-7472",
                "phone": "2484997472",
                "address": "3375 Orchard Lake Rd",
                "city": "Keego Harbor",
                "country": "United States",
                "postalCode": "48320",
                "state": "MI",
                "url": "https://peopleskateandsnowboard.com/"
            }
        },
        {
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -84.8499504,
                    39.090891
                ]
            },
            "properties": {
                "name": "Perfect North Slopes",
                "phoneFormatted": "(812) 537-3754",
                "phone": "8125373754",
                "address": "19074 Perfect Lane",
                "city": "Lawrenceburg",
                "country": "United States",
                "postalCode": "47025",
                "state": "IN",
                "url": "https://perfectnorth.com/"
            }
        },
        {
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -117.6340458,
                    34.3608023
                ]
            },
            "properties": {
                "name": "Pharmacy",
                "phoneFormatted": "(760) 249-1900",
                "phone": "7602491900",
                "address": "1433 CA-2",
                "city": "Wrightwood",
                "country": "United States",
                "postalCode": "92397",
                "state": "CA",
                "url": "https://pharmacyboardshop.com/"
            }
        },
        {
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -93.3871758,
                    45.1977428
                ]
            },
            "properties": {
                "name": "Pinewski's",
                "phoneFormatted": "(763) 422-0329",
                "phone": "7634220329",
                "address": "546 W Main St",
                "city": "Anoka",
                "country": "United States",
                "postalCode": "55303",
                "state": "MN",
                "url": "https://www.pinewskis.com/"
            }
        },
        {
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -74.0130338365868,
                    41.9343075147569
                ]
            },
            "properties": {
                "name": "Potter Brothers Ski and Snowboard Shop",
                "phoneFormatted": "(845) 338-5119",
                "phone": "8453385119",
                "address": "57 City View Terrace",
                "city": "Kingston",
                "country": "United States",
                "postalCode": "12401",
                "state": "NY",
                "url": "https://potterbrothers.com/"
            }
        },
        {
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -76.520945130497,
                    38.9836516317018
                ]
            },
            "properties": {
                "name": "Pure Boardshop",
                "phoneFormatted": "(410) 267-7669",
                "phone": "4102677669",
                "address": "1908 Forest Dr",
                "city": "Annapolis",
                "country": "United States",
                "postalCode": "21401",
                "state": "MD",
                "url": "https://www.pureboardshop.com/"
            }
        },
        {
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -81.6654535410217,
                    36.2106337066115
                ]
            },
            "properties": {
                "name": "Recess Skate & Snow",
                "phoneFormatted": "(828) 355-9013",
                "phone": "8283559013",
                "address": "1158 NC-105",
                "city": "Boone",
                "country": "United States",
                "postalCode": "28607",
                "state": "NC",
                "url": "https://recessrideshop.com/"
            }
        },
        {
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -97.7436995,
                    30.2711286
                ]
            },
            "properties": {
                "name": "Saint Bernard - Austin",
                "phoneFormatted": "(737) 304-7003",
                "phone": "7373047003",
                "address": "3201 Bee Caves Road",
                "city": "Austin",
                "country": "United States",
                "postalCode": "78746",
                "state": "TX",
                "url": "https://www.saintbernard.com/"
            }
        },
        {
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -96.829211704,
                    32.839929635
                ]
            },
            "properties": {
                "name": "Saint Bernard - Dallas",
                "phoneFormatted": "(214) 357-9700",
                "phone": "2143579700",
                "address": "5570 W. Lovers Ln #388",
                "city": "Dallas",
                "country": "United States",
                "postalCode": "75209",
                "state": "TX",
                "url": "https://www.saintbernard.com/"
            }
        },
        {
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -95.448820147,
                    29.741412284
                ]
            },
            "properties": {
                "name": "Saint Bernard - Houston",
                "phoneFormatted": "(713) 388-6888",
                "phone": "7133886888",
                "address": "4444 Westheimer RD G100",
                "city": "Houston",
                "country": "United States",
                "postalCode": "77027",
                "state": "TX",
                "url": "https://www.saintbernard.com/"
            }
        },
        {
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -98.458577974,
                    29.486133111
                ]
            },
            "properties": {
                "name": "Saint Bernard - San Antonio",
                "phoneFormatted": "(726) 208-0477",
                "phone": "7262080477",
                "address": "999 E. Basse RD Suite 157",
                "city": "San Antonio",
                "country": "United States",
                "postalCode": "78209",
                "state": "TX",
                "url": "https://www.saintbernard.com/"
            }
        },
        {
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -97.1460236061565,
                    32.9427141194371
                ]
            },
            "properties": {
                "name": "Saint Bernard - Southlake",
                "phoneFormatted": "(817) 329-0322",
                "phone": "8173290322",
                "address": "1275 E. Southlake BLVD Suite #401",
                "city": "Southlake",
                "country": "United States",
                "postalCode": "76092",
                "state": "TX",
                "url": "https://www.saintbernard.com/"
            }
        },
        {
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -105.217283146641,
                    40.0476636491915
                ]
            },
            "properties": {
                "name": "Satellite Boardshop",
                "phoneFormatted": "(303) 374-3275",
                "phone": "3033743275",
                "address": "3044 Valmont Rd",
                "city": "Boulder",
                "country": "United States",
                "postalCode": "80301",
                "state": "CO",
                "url": "https://www.satelliteboardshop.com/"
            }
        },
        {
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -83.6869658857142,
                    43.0116565544303
                ]
            },
            "properties": {
                "name": "Shumaker's Ski Shop",
                "phoneFormatted": "(810) 239-6931",
                "phone": "8102396931",
                "address": "2342 S Ballenger Hwy",
                "city": "Flint",
                "country": "United States",
                "postalCode": "48503",
                "state": "MI",
                "url": "https://www.facebook.com/people/Shumakers-Ski-Snowboard/100064083965994/"
            }
        },
        {
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -83.9145535211428,
                    42.5940066766666
                ]
            },
            "properties": {
                "name": "Skaters Advocate",
                "phoneFormatted": "(517) 545-9366",
                "phone": "5175459366",
                "address": "106 N State St",
                "city": "Howell",
                "country": "United States",
                "postalCode": "48843",
                "state": "MI",
                "url": "https://www.skatersadvocate.com/"
            }
        },
        {
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -74.0682613856975,
                    40.9449815921453
                ]
            },
            "properties": {
                "name": "Ski Barn - Parasmus",
                "phoneFormatted": "(201) 445-9070",
                "phone": "2014459070",
                "address": "846 Route 17 North",
                "city": "Paramus",
                "country": "United States",
                "postalCode": "07652",
                "state": "NJ",
                "url": "https://skibarn.com/"
            }
        },
        {
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -74.2481108511521,
                    40.9455920073035
                ]
            },
            "properties": {
                "name": "Ski Barn - Wayne",
                "phoneFormatted": "(973) 256-8585",
                "phone": "9732568585",
                "address": "1308 Route 23 North",
                "city": "Wayne",
                "country": "United States",
                "postalCode": "07470",
                "state": "NJ",
                "url": "https://skibarn.com/"
            }
        },
        {
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -74.6808933,
                    40.2971555
                ]
            },
            "properties": {
                "name": "Ski Barn - Lawrenceville",
                "phoneFormatted": "(609) 530-1666",
                "phone": "6095301666",
                "address": "2990 Brunswick Pike",
                "city": "Lawrenceville",
                "country": "United States",
                "postalCode": "08648",
                "state": "NJ",
                "url": "https://skibarn.com/"
            }
        },
        {
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -74.0589915970588,
                    40.3256990568627
                ]
            },
            "properties": {
                "name": "Ski Barn - Shrewsbury",
                "phoneFormatted": "(732) 945-3900",
                "phone": "7329453900",
                "address": "795 Broad Street",
                "city": "Shrewsbury",
                "country": "United States",
                "postalCode": "07702",
                "state": "NJ",
                "url": "https://skibarn.com/"
            }
        },
        {
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -80.7492209268493,
                    41.1914028216438
                ]
            },
            "properties": {
                "name": "Ski Chalet",
                "phoneFormatted": "(330) 652-7913",
                "phone": "3306527913",
                "address": "1041 Youngstown-Warren Rd.",
                "city": "Niles",
                "country": "United States",
                "postalCode": "44446",
                "state": "OH",
                "url": "https://theskichalet.com/"
            }
        },
        {
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -111.847164363569,
                    33.3781345072948
                ]
            },
            "properties": {
                "name": "Ski Pro Mesa",
                "phoneFormatted": "(480) 962-6910",
                "phone": "4809626910",
                "address": "1924 W Rio Salado Pkwy",
                "city": "Mesa",
                "country": "United States",
                "postalCode": "85210",
                "state": "AZ",
                "url": "https://skipro.com/"
            }
        },
        {
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -112.001532397114,
                    33.6791838252122
                ]
            },
            "properties": {
                "name": "Ski Pro Desert Ridge",
                "phoneFormatted": "(480) 443-5670",
                "phone": "4804435670",
                "address": "21001 N Tatum Blvd",
                "city": "Phoenix",
                "country": "United States",
                "postalCode": "85050",
                "state": "AZ",
                "url": "https://skipro.com/"
            }
        },
        {
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -119.812658,
                    39.5261788
                ]
            },
            "properties": {
                "name": "Ski Pro Reno",
                "phoneFormatted": "(775) 420-3427",
                "phone": "7754203427",
                "address": "6407 S Virginia St",
                "city": "Reno",
                "country": "United States",
                "postalCode": "89511",
                "state": "NV",
                "url": "https://skipro.com/"
            }
        },
        {
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -82.5154471,
                    40.75839
                ]
            },
            "properties": {
                "name": "Snow Trails Ski Shop",
                "phoneFormatted": "(419) 756-3105",
                "phone": "4197563105",
                "address": "3100 Possum Run Rd",
                "city": "Mansfield",
                "country": "United States",
                "postalCode": "44904",
                "state": "OH",
                "url": "https://www.snowtrails.com/footer/snow-trails-ski-shop"
            }
        },
        {
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -71.4547891,
                    42.9956397
                ]
            },
            "properties": {
                "name": "Snowboard Jones",
                "phoneFormatted": "(603) 627-7433",
                "phone": "6036277433",
                "address": "150 Kaye St",
                "city": "Manchester",
                "country": "United States",
                "postalCode": "03103",
                "state": "NH",
                "url": "https://www.snowboardjones.com/"
            }
        },
        {
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -72.8521549021176,
                    44.1123809635294
                ]
            },
            "properties": {
                "name": "Splinters Boardshop",
                "phoneFormatted": "(802) 496-7441",
                "phone": "8024967441",
                "address": "18 Sugarbush Access Rd",
                "city": "Warren",
                "country": "United States",
                "postalCode": "05674",
                "state": "VT",
                "url": "https://splintersboardshop.com/"
            }
        },
        {
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -121.7058456125,
                    47.8614770024999
                ]
            },
            "properties": {
                "name": "Stevens Pass Snowboard Shop",
                "phoneFormatted": "(360) 793-0221",
                "phone": "3607930221",
                "address": "617 Croft Ave W",
                "city": "Gold Bar",
                "country": "United States",
                "postalCode": "98251",
                "state": "WA",
                "url": "https://www.stevenspasssnowboardshop.com/"
            }
        },
        {
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -117.91768864286,
                    33.6461964374135
                ]
            },
            "properties": {
                "name": "Surfside Sports",
                "phoneFormatted": "(949) 645-4624",
                "phone": "9496454624",
                "address": "233 E 17th St",
                "city": "Costa Mesa",
                "country": "United States",
                "postalCode": "92627",
                "state": "CA",
                "url": "https://www.surfsidesports.com/"
            }
        },
        {
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -121.32008535004,
                    44.0856462370612
                ]
            },
            "properties": {
                "name": "Tactics Bend",
                "phoneFormatted": "(541) 640-8265",
                "phone": "5416408265",
                "address": "933 NW Wall St.",
                "city": "Bend",
                "country": "United States",
                "postalCode": "97703",
                "state": "OR",
                "url": "https://www.tactics.com/"
            }
        },
        {
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -123.07737802,
                    44.071059846
                ]
            },
            "properties": {
                "name": "Tactics Eugene",
                "phoneFormatted": "(541) 349-0687",
                "phone": "5413490687",
                "address": "375 W 4th Ave.",
                "city": "Eugene",
                "country": "United States",
                "postalCode": "97401",
                "state": "OR",
                "url": "https://www.tactics.com/"
            }
        },
        {
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -122.685116574599,
                    45.5286739745992
                ]
            },
            "properties": {
                "name": "Tactics Portland",
                "phoneFormatted": "(503) 224-0982",
                "phone": "5032240982",
                "address": "901 NW Davis St.",
                "city": "Portland",
                "country": "United States",
                "postalCode": "97209",
                "state": "OR",
                "url": "https://www.tactics.com/"
            }
        },
        {
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -123.0724287,
                    49.3279933
                ]
            },
            "properties": {
                "name": "The Boardroom - North Vancouver",
                "phoneFormatted": null,
                "phone": null,
                "address": "1465 Charlotte Road",
                "city": "North Vancouver",
                "country": "Canada",
                "postalCode": "V7M 2K4",
                "state": "British Columbia",
                "url": "https://boardroomshop.com"
            }
        },
        {
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -78.6727799,
                    42.2751873
                ]
            },
            "properties": {
                "name": "The Boardroom Snowboard Shop",
                "phoneFormatted": "(716) 699-5620",
                "phone": "7166995620",
                "address": "6113 Route 219 S",
                "city": "Ellicottville",
                "country": "United States",
                "postalCode": "14731",
                "state": "NY",
                "url": "https://www.boardsandpowder.com/"
            }
        },
        {
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -85.5740258549935,
                    42.205853140856
                ]
            },
            "properties": {
                "name": "The Edge",
                "phoneFormatted": "(269) 327-1000",
                "phone": "2693271000",
                "address": "9009 Portage Rd",
                "city": "Portage",
                "country": "United States",
                "postalCode": "49002",
                "state": "MI",
                "url": "https://www.edgeski.com/"
            }
        },
        {
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -73.2541069,
                    42.4484778
                ]
            },
            "properties": {
                "name": "The Garden",
                "phoneFormatted": "(413) 442-9088",
                "phone": "4134429088",
                "address": "148 North St",
                "city": "Pittsfield",
                "country": "United States",
                "postalCode": "01201",
                "state": "MA",
                "url": "https://www.gardenma.com/"
            }
        },
        {
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -75.4904323,
                    39.919698
                ]
            },
            "properties": {
                "name": "The Ski Bum",
                "phoneFormatted": "(610) 459-4778",
                "phone": "6104594778",
                "address": "200 Town Centre Drive #9",
                "city": "Glen Mills",
                "country": "United States",
                "postalCode": "19342",
                "state": "PA",
                "url": "https://www.theskibum.com/"
            }
        },
        {
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -75.7436049503474,
                    39.6946824507264
                ]
            },
            "properties": {
                "name": "The Ski Bum",
                "phoneFormatted": "(302) 454-9829",
                "phone": "3024549829",
                "address": "218 East Main St",
                "city": "Newark",
                "country": "United States",
                "postalCode": "19711",
                "state": "DE",
                "url": "https://www.theskibum.com/"
            }
        },
        {
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -77.4347128,
                    42.8950641
                ]
            },
            "properties": {
                "name": "The Ski Company Bloomfield/Canadaigua",
                "phoneFormatted": "(585) 657-7785",
                "phone": "5856577785",
                "address": "3036 Route 64 South",
                "city": "Bloomfield",
                "country": "United States",
                "postalCode": "14469",
                "state": "NY",
                "url": "https://www.skicompany.com/"
            }
        },
        {
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -78.7301657421141,
                    42.9814601473194
                ]
            },
            "properties": {
                "name": "The Ski Company Buffalo",
                "phoneFormatted": "(716) 204-3162",
                "phone": "7162043162",
                "address": "4169 Transit Rd",
                "city": "Williamsville",
                "country": "United States",
                "postalCode": "14221",
                "state": "NY",
                "url": "https://www.skicompany.com/"
            }
        },
        {
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -77.615214,
                    43.157285
                ]
            },
            "properties": {
                "name": "The Ski Company Rochester",
                "phoneFormatted": "(585) 292-0580",
                "phone": "5852920580",
                "address": "1225 Jefferson Rd",
                "city": "Rochester",
                "country": "United States",
                "postalCode": "14623",
                "state": "NY",
                "url": "https://www.skicompany.com/"
            }
        },
        {
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -76.075728287441,
                    43.0406051943166
                ]
            },
            "properties": {
                "name": "The Ski Company Syracuse",
                "phoneFormatted": "(315) 445-1890",
                "phone": "3154451890",
                "address": "3401 Erie Boulevard East",
                "city": "Syracuse",
                "country": "United States",
                "postalCode": "13214",
                "state": "NY",
                "url": "https://www.skicompany.com/"
            }
        },
        {
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -72.6075851,
                    42.2071184
                ]
            },
            "properties": {
                "name": "Theory Skateshop",
                "phoneFormatted": "(413) 534-7669",
                "phone": "4135347669",
                "address": "50 Holyoke St",
                "city": "Holyoke",
                "country": "United States",
                "postalCode": "01040",
                "state": "MA",
                "url": "https://theoryskate.com/"
            }
        },
        {
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -121.7547596,
                    45.3041033
                ]
            },
            "properties": {
                "name": "Timberline Lodge",
                "phoneFormatted": "(503) 272-3311",
                "phone": "5032723311",
                "address": "27500 E Timberline Road",
                "city": "Government Camp",
                "country": "United States",
                "postalCode": "97028",
                "state": "OR",
                "url": "https://www.timberlinelodge.com/"
            }
        },
        {
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -84.263826,
                    39.2689476
                ]
            },
            "properties": {
                "name": "Vertical Drop",
                "phoneFormatted": "(513) 583-5822",
                "phone": "5135835822",
                "address": "110 S. 2nd St Suite J",
                "city": "Loveland",
                "country": "United States",
                "postalCode": "45140",
                "state": "OH",
                "url": "https://verticaldropoutdoors.com/"
            }
        },
        {
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -111.034876758341,
                    45.6839544471502
                ]
            },
            "properties": {
                "name": "World Boards",
                "phoneFormatted": "(406) 587-1707",
                "phone": "4065871707",
                "address": "601 W Main St",
                "city": "Bozeman",
                "country": "United States",
                "postalCode": "59715",
                "state": "MT",
                "url": "https://www.worldboards.com/"
            }
        },
        {
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -93.2893004526547,
                    44.7300271064924
                ]
            },
            "properties": {
                "name": "Zombie Boardshop",
                "phoneFormatted": "(952) 892-0047",
                "phone": "9528920047",
                "address": "15100 Buck Hill Rd",
                "city": "Burnsville",
                "country": "United States",
                "postalCode": "55306",
                "state": "MN",
                "url": "https://www.zombieboardshop.com/"
            }
        }
    ]
};